import {isEmpty, map} from 'lodash';
import {useMemo} from 'react';
import {useTranslation} from 'react-i18next';

import {Icon, Table, TableBody, TableCell, TableRow} from 'components';
import {TRANSLATION_KEYS} from 'locale';
import {DomainInfo} from 'types';

const T_KEYS = TRANSLATION_KEYS.USER.ACCOUNT.SETTINGS.CSP_WHITELIST;

type Props = {
    infos: DomainInfo[];
    renderCreatedBy: (eid: number) => React.ReactElement;
    renderCreatedAt: (date: Date) => string;
    className?: string;
    onDelete: (index: number) => void;
}

export const WhitelistTable: React.FC<Props> = ({infos, renderCreatedBy, renderCreatedAt, className, onDelete}) => {
    const {t} = useTranslation();
    const headers = useMemo(() => [
        {children: t(T_KEYS.HEADERS.DOMAIN), className: 'tw-w-64'},
        {children: t(T_KEYS.HEADERS.CREATED_BY)},
        {children: t(T_KEYS.HEADERS.CREATED_AT)},
        {children: t(T_KEYS.HEADERS.DESCRIPTION)},
        {children: t(T_KEYS.HEADERS.ACTIONS), className: 'tw-w-24'}
    ], [t]);

    return (
        <Table headers={headers} noData={isEmpty(infos)} className={className}>
            <TableBody>
                {map(infos, (info, index) => (
                    <TableRow key={info.id || info.domain}>
                        <TableCell>{info.domain}</TableCell>
                        <TableCell>{renderCreatedBy(info.createdBy)}</TableCell>
                        <TableCell>{renderCreatedAt(info.createdAt)}</TableCell>
                        <TableCell>{info.description}</TableCell>
                        <TableCell className='tw-w-24'>
                            <Icon name='delete' color='alert' button onClick={() => onDelete(index)} />
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
};